import React, { useRef, useState, useEffect } from "react";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  CopyOutlined,
  FilePdfOutlined,
  SearchOutlined,
  SmallDashOutlined,
} from "@ant-design/icons";
import { CalendarOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import {
  Button,
  Checkbox, 
  Dropdown,
  Input,
  Menu,
  Space,
  Table,
  Tooltip,
} from "antd";
import { useNavigate } from "react-router-dom";
import firebase from "../../config/firebase";
import { doc, getDoc } from "firebase/firestore";
import { useSelector } from "react-redux";
import Stack from "@mui/material/Stack";
import { Chip } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { format } from "date-fns";
import DatePickerMenu from "../dataPicker/dataPickerMenu";
import ModernAlertDialog from "../../view/frete/components/ModernAlertDialog";
import ModalFilter from "../ModalFilter/ModalFilter";
import dayjs from "dayjs";
import Utils from "../../util/utils";
import userService from "../../service/user.service";
// CHANGED: util file renamed from pdfOrcamento.js to generateBugetPdf.js
import { gerarPdfOrcamento } from "../../util/generateBugetPdf";
import {
  deleteBudgetById,
  fetchBudgetGetAll,
  fetchBudgetById,
  updateBudget,
} from "../../view/budget/action/action";
import { GlobalConfirmModal, GlobalSuccessModal } from "../modalGlobal/modalGlobal";
require("firebase/auth");

const DataOrcamentoTable = ({
  cleanFilter,
  openFilter,
  onCleanFilterHandled,
  onOpenFilterHandled,
}) => {
  const db = firebase.firestore();
  const navigate = useNavigate();

  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [openModalFilter, setOpenModalFilter] = useState(false);
  const [datas, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sellersList, setSellersList] = useState([]);

  const [dateRange, setDateRange] = useState([]);
  const unsubscribeBudgetRef = useRef(null);
  const hasLoadedRef = useRef(false);
  const [columnFilters, setColumnFilters] = useState({});
  const [statusSearchText, setStatusSearchText] = useState("");
  const statusFilterRef = useRef(null);

  const [pageSize, setPageSize] = useState(10);
  const [current, setCurrent] = useState(1);
  const [actionModalOpen, setActionModalOpen] = useState(false);
  const [actionModalConfig, setActionModalConfig] = useState({
    title: "Confirmar Ação",
    message: "Você deseja confirmar esta etapa?",
  });
  const [pendingStatusChange, setPendingStatusChange] = useState(null);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [successModalTitle, setSuccessModalTitle] = useState("");

  const budgetModalFilterColumns = [
    { key: "dataCriacao", label: "Data de CriaÃ§Ã£o", type: "date" },
    { key: "clientPayment.name", label: "Pagador", type: "text" },
    { key: "sellerName", label: "Vendedor", type: "text" },
    { key: "firstDelivery.city", label: "Origem", type: "text" },
    { key: "lastDelivery.city", label: "Destino", type: "text" },
    { key: "veiculoCarroceria", label: "VeÃ­culo/Carroceria", type: "text" },
    { key: "summary.valueFreightage", label: "Valor Total", type: "number" },
    { key: "status.describe", label: "Status", type: "select" },
  ];

  const budgetStatusOptions = [
    { value: "Em Aberto", label: "Em Aberto" },
    { value: "Enviado", label: "Enviado" },
    { value: "Aprovado", label: "Aprovado" },
    { value: "Cancelado", label: "Cancelado" },
  ];

  const storageKey = (uid, key) => `${uid}:${key}`;

  const handleDateRangeChange = (dates) => {
    setDateRange(dates ? [dates[0], dates[1]] : []);
  };

  const searchInput = useRef(null);

  const user = useSelector((state) => state.user);

  useEffect(() => {
    async function loadSellers() {
      try {
        // Mantem em memoria os dados do cadastro de usuarios para enriquecer o PDF com telefone e e-mail.
        const list = await userService.usersAssociatedWithFortio();
        setSellersList(list);
      } catch (error) {
        console.error("Erro ao carregar vendedores:", error);
      }
    }

    loadSellers();
  }, []);
  //ACESSA O BACK ATRAVES DO GET ALL PARA BUSCAR OS DADOS DA LISTA DE ORCAMENTO
  const fetchData = async () => {
    setLoading(true); // liga o spinner/estado de carregamento da tabela antes de começar a buscar

    try {
      const query1 = await fetchBudgetGetAll(user); 
// chama a action que faz GET /v1/pickup-budget?idUser=... já filtrado pelo backend
      

      if (query1.success) {
        // fetchBudgetGetAll sempre devolve { success, data } ou { success:false, error }; aqui checa se deu certo
       
       
        // Prepara o enriquecimento de cada um (decide se precisa buscar vendedor).
        const documents = await Promise.all(
          // roda o enriquecimento de todos os orçamentos em paralelo (não um por um)
          query1.data.map(async (docData) => {
            let sellerName = ""; // valor padrão caso não ache o vendedor
            
            if (docData.user?.uid) {  // só busca se o orçamento tiver o uid do vendedor gravado
             
             
              // Busca o vendedor numa coleção separada, só pra pegar o nome — sem tocar nos dados do orçamento.
            //"Busca o nome do vendedor no Firestore com tratamento de erro, e d
              try {
                const userRef = doc(db, "users", docData.user.uid); // aponta pro documento users/{uid} do vendedor
                const userSnap = await getDoc(userRef); // lê o documento direto do Firestore (chamada de rede no front)
                if (userSnap.exists()) {
                  // só usa o dado se o documento realmente existir
                  sellerName = userSnap.data().name || ""; // pega o campo "name"; se vier vazio, mantém ""
                }
              } catch (error) {
                console.error("Erro ao buscar vendedor:", error);
              }
            }

            return {
              ...docData, // mantém todos os campos originais do orçamento
              sellerName, // acrescenta o nome do vendedor buscado acima
              createdAt:
                docData.createData || docData.firstDelivery?.dateColeta, // data de criação, com fallback pra data de coleta
            };
          }),
        );

        setData(documents); // salva a lista já enriquecida (com sellerName/createdAt) no estado usado pela <Table> do AntD
      } else {
        console.error("Erro ao buscar orçamento:", query1.error); // API respondeu, mas com success:false (erro tratado, ex: falha de rede na action)
      }
    } catch (error) {
      console.error("Erro inesperado ao buscar orçamento:", error); // pega qualquer erro não tratado (ex: bug no próprio .map/Promise.all acima)
    } finally {
      setLoading(false); // desliga o spinner sempre, tenha dado certo ou não
    }
  };

  // const fetchData = () => {
  //   // Limpa o listener anterior se existir
  //   if (unsubscribeBudgetRef.current) {
  //     unsubscribeBudgetRef.current();
  //     unsubscribeBudgetRef.current = null;
  //   }

  //   // Define loading como true ao iniciar
  //   setLoading(true);

  //   let query;
  //   let query1;

  //   query1 = fetchBudgetGetAll();
  //   console.log(query1);

  //   // Cria a query baseada nas condiÃ§Ãµes do usuÃ¡rio
  //   // if (user.viewALL) {
  //   //   query = firebase.firestore().collection("tb_budget");
  //   // } else {
  //   //   if (
  //   //     user?.uidShipperAffiliates &&
  //   //     Array.isArray(user.uidShipperAffiliates)
  //   //   ) {
  //   //     const affiliateUids = Array.isArray(user?.uidShipperAffiliates)
  //   //     ? user.uidShipperAffiliates
  //   //       : [];
  //   //       const primaryUid = user?.uidShipper ? [user.uidShipper] : [];
  //   //       const uids = Array.from(new Set([...affiliateUids, ...primaryUid]));

  //   //     if (uids.length > 1) {
  //   //       query = firebase
  //   //         .firestore()
  //   //         .collection("tb_budget")
  //   //         .where("clientPayment.uid", "in", uids);
  //   //       } else {
  //   //         query = firebase
  //   //         .firestore()
  //   //         .collection("tb_budget")
  //   //         .where("clientPayment.uid", "==", user.uidShipper);
  //   //       }
  //   //     } else {
  //   //       query = firebase
  //   //       .firestore()
  //   //       .collection("tb_budget")
  //   //       .where("clientPayment.uid", "==", user.uidShipper);
  //   //     }
  //   // }

  //   debugger;
  //   // Cria o listener com onSnapshot

  //   const unsubscribe = query1.onSnapshot(
  //     async (snapshot) => {
  //       const documents = await Promise.all(
  //         snapshot.docs.map(async (docSnap) => {
  //           const docData = docSnap.data();

  //           // Buscar dados do vendedor se existir
  //           let sellerName = "";
  //           if (docData.user?.uid) {
  //             try {
  //               const userRef = doc(db, "users", docData.user.uid);
  //               const userSnap = await getDoc(userRef);
  //               if (userSnap.exists()) {
  //                 sellerName = userSnap.data().name || "";
  //               }
  //             } catch (error) {
  //               console.error("Erro ao buscar vendedor:", error);
  //             }
  //           }

  //           return {
  //             id: docSnap.id,
  //             ...docData,
  //             sellerName: sellerName,
  //             createdAt:
  //               docData.createData || docData.firstDelivery?.dateColeta,
  //           };
  //         }),
  //       );

  //       setData(documents);
  //       setLoading(false);
  //     },
  //     (error) => {
  //       console.error("Erro ao buscar dados:", error);
  //       setLoading(false);
  //     },
  //   );

  //   unsubscribeBudgetRef.current = unsubscribe;
  // };

  useEffect(() => {
    if (user) {
      fetchData();
    }

    // Cleanup quando o componente desmontar ou user mudar
    return () => {
      if (unsubscribeBudgetRef.current) {
        unsubscribeBudgetRef.current();
        unsubscribeBudgetRef.current = null;
      }
    };
  }, [user]);

  useEffect(() => {
    // load do localStorage com base na filtragem
    if (!user?.uid) return;

    const savedDateRange = localStorage.getItem(
      storageKey(user.uid, "orcamentoDateRangeFilter"),
    );

    const savedColumnFilters = localStorage.getItem(
      storageKey(user.uid, "orcamentoColumnFilters"),
    );

    if (savedColumnFilters) {
      setColumnFilters(JSON.parse(savedColumnFilters));
    } else {
      setColumnFilters({});
    }

    if (savedDateRange) {
      const parsed = JSON.parse(savedDateRange);

      const normalized =
        Array.isArray(parsed) && parsed.length === 2
          ? parsed.map((d) => dayjs(d))
          : null;

      setDateRange(normalized);
      setSearchedColumn("dataCriacao");
    } else {
      setDateRange(null);
    }

    hasLoadedRef.current = true;
  }, [user?.uid]);

  useEffect(() => {
    // Save do localStorage com base na filtragem
    if (!hasLoadedRef.current) return;
    if (!user?.uid) return;

    if (dateRange) {
      localStorage.setItem(
        storageKey(user.uid, "orcamentoDateRangeFilter"),
        JSON.stringify(dateRange),
      );
    } else {
      localStorage.removeItem(storageKey(user.uid, "orcamentoDateRangeFilter"));
    }

    if (columnFilters && Object.keys(columnFilters).length) {
      localStorage.setItem(
        storageKey(user.uid, "orcamentoColumnFilters"),
        JSON.stringify(columnFilters),
      );
    } else {
      localStorage.removeItem(storageKey(user.uid, "orcamentoColumnFilters"));
    }
  }, [user?.uid, dateRange, columnFilters]);

  useEffect(() => {
    if (cleanFilter) {
      cleanFilters();
      onCleanFilterHandled?.();
    }
  }, [cleanFilter]);

  useEffect(() => {
    if (openFilter) {
      setOpenModalFilter(true);
      onOpenFilterHandled?.();
    }
  }, [openFilter]);

  const handleOpen = () => {
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleSearch = (selectedKeys, confirm, columnKey) => {
    const rawValue = selectedKeys?.[0];
    confirm();
    setColumnFilters((prev) => ({
      ...prev,
      [columnKey]:
        columnKey === "summary.valueFreightage" || columnKey === "valorTotal"
          ? Utils.moneyToInt(rawValue || 0)
          : String(rawValue ?? ""),
    }));
  };

  const handleSearchDate = (confirm) => {
    confirm();
    setSearchText("");
    setSearchedColumn("dataCriacao");
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setColumnFilters((prev) => {
      const updatedFilters = { ...prev };
      delete updatedFilters[searchedColumn];
      return updatedFilters;
    });
  };

  const handleResetDate = (clearFilters) => {
    clearFilters();
    setDateRange([]);
  };

  const deletebuget = async (id) => {
    if (!id) return;

    try {
      const resultDelete = await deleteBudgetById(id);

      if (!resultDelete.success) {
        throw new Error(resultDelete.error || "Erro ao excluir o orcamento");
      }

      setSuccessModalTitle("Orçamento excluído com sucesso!");
      setOpenSuccessModal(true);
      fetchData();
    } catch (error) {
      console.error("Erro ao excluir o orcamento:", error);
      setActionModalConfig({
        title: "Erro",
        message: `Erro ao excluir o orcamento: ${error.message}`,
      });
      setPendingStatusChange(null);
      setActionModalOpen(true);
    }
  };

  const statusCodeByDescribe = {
    "Em Aberto": "01",
    Enviado: "02",
    Aprovado: "03",
    Cancelado: "04",
  };

  const updateBudgetStatus = async (id, describe) => {
    if (!id || !describe) return;

    // ANTIGO (Firestore direto) — mantido comentado so para estudo, nao apagar:
    // Lia o doc so pra checar o status atual e depois dava um .update() parcial
    // so no campo status, direto no Firestore.
    //
    // try {
    //   const budgetRef = db.collection("tb_budget").doc(id);
    //   const budgetSnapshot = await budgetRef.get();
    //   const currentStatus = budgetSnapshot.data()?.status?.describe;
    //
    //   if (
    //     currentStatus === "Aprovado" &&
    //     !["Aprovado", "Cancelado"].includes(describe)
    //   ) {
    //     return;
    //   }
    //
    //   const code = statusCodeByDescribe[describe];
    //   const statusPayload = code ? { describe, code } : { describe };
    //   await budgetRef.update({
    //     status: statusPayload,
    //   });
    // } catch (error) {
    //   console.error("Erro ao atualizar status do orÃ§amento:", error);
    //   alert("Erro ao atualizar status do orÃ§amento: " + error.message);
    // }

    // NOVO (via API REST) — busca o orcamento inteiro (fetchBudgetById) porque
    // o PATCH /v1/pickup-budget/:id valida o payload completo (BudgetSchema no
    // back nao aceita update parcial), depois manda tudo de volta so trocando status.
    try {
      const budgetLookup = await fetchBudgetById(id);
      if (!budgetLookup.success || !budgetLookup.data) {
        alert("Orçamento não encontrado");
        return;
      }

      const currentStatus = budgetLookup.data?.status?.describe;

      // Regra de negocio: depois de aprovado, o orcamento so pode ser cancelado.
      if (
        currentStatus === "Aprovado" &&
        !["Aprovado", "Cancelado"].includes(describe)
      ) {
        return;
      }

      const code = statusCodeByDescribe[describe];
      const statusPayload = code ? { describe, code } : { describe };

      const result = await updateBudget(id, {
        ...budgetLookup.data,
        status: statusPayload,
      });

      if (!result.success) {
        throw new Error(result.error || "Erro ao atualizar status do orçamento");
      }
    } catch (error) {
      console.error("Erro ao atualizar status do orçamento:", error);
      alert("Erro ao atualizar status do orçamento: " + error.message);
    }
  };

  const handleBudgetStatusChange = (id, nextStatus) => {
    if (!id || !nextStatus) return;

    if (nextStatus === "Cancelado") {
      setActionModalConfig({
        title: "Confirmar Ação",
        message: "Você deseja realmente cancelar o Orçamento?",
      });
    } else if (nextStatus === "Excluir") {
      setActionModalConfig({
        title: "Confirmar Ação",
        message: "Deseja mesmo excluir ?",
      });
    } else if (nextStatus === "Duplicar") {
      setActionModalConfig({
        title: "Confirmar Ação",
        message: "Deseja mesmo duplicar o Orçamento?",
      });
    } else {
      setActionModalConfig({
        title: "Confirmar Ação",
        message: "Você deseja realmente aprovar este Orçamento?",
      });
    }

    setPendingStatusChange({ id, nextStatus });
    setActionModalOpen(true);
  };
  const handleApproveBudgetFromList = async (record) => {
    if (!record?.id) return;

    // ANTIGO (Firestore direto) — mantido comentado so para estudo, nao apagar:
    // Buscava o doc principal e a subcolecao stopping_points em duas idas
    // separadas ao Firestore, direto do front.
    //
    // const budgetDoc = await db.collection("tb_budget").doc(record.id).get();
    // if (!budgetDoc.exists) {
    //   setActionModalConfig({
    //     title: "Erro",
    //     message: "Orcamento nao encontrado",
    //   });
    //   setPendingStatusChange(null);
    //   setActionModalOpen(true);
    //   setLoading(false);
    //   return false;
    // }
    //
    // const budgetData = budgetDoc.data();
    //
    // const stopsSnapshot = await db
    //   .collection("tb_budget")
    //   .doc(record.id)
    //   .collection("stopping_points")
    //   .get();
    //
    // const stops = [];
    // stopsSnapshot.docs.forEach((docSnap) => {
    //   stops.push({ id: docSnap.id, ...docSnap.data() });
    // });

    try {
      setLoading(true);

      // NOVO (via API REST) — GET /v1/pickup-budget/:id ja devolve o orcamento
      // com os stopping_points embutidos, numa chamada so. apos aprovar o orcamento.
      const budgetLookup = await fetchBudgetById(record.id);
      if (!budgetLookup.success || !budgetLookup.data) {
        setActionModalConfig({
          title: "Erro",
          message: "Orcamento nao encontrado",
        });
        setPendingStatusChange(null);
        setActionModalOpen(true);
        setLoading(false);
        return false;
      }

      const budgetData = budgetLookup.data;
      const stops = budgetData.stopping_points || [];

      const freightData = {
        fromBudget: true,
        budgetId: record.id,
        budgetData: budgetData,
        stops: stops,
        clientPayment: budgetData.clientPayment,
        vehicle: budgetData.vehicle,
        pricing: budgetData.pricing,
        summary: budgetData.summary,
        numberSerial: budgetData.numberSerial,
      };

      navigate("/freightCopy", { state: freightData });
      setLoading(false);
      return true;
    } catch (error) {
      console.error("Erro ao aprovar orÃ§amento:", error);
      alert("Erro ao aprovar orÃ§amento");
      setLoading(false);
    }
  };

  const handleDuplicateBudget = async (id) => {
    try {
      if (!id) return;

      navigate(`/budget/${id}?isCopy=true`, { state: { isCopy: true } });
    } catch (error) {
      console.error("Erro ao duplicar orçamento:", error);
      alert("Erro ao duplicar orçamento");
    }
  };

  const handleActionConfirm = async () => {
    if (!pendingStatusChange) {
      setActionModalOpen(false);
      return;
    }

    if (pendingStatusChange.nextStatus === "Cancelado") {
      await updateBudgetStatus(
        pendingStatusChange.id,
        pendingStatusChange.nextStatus,
      );
    } else if (pendingStatusChange.nextStatus === "Aprovado") {
      const approved = await handleApproveBudgetFromList({
        id: pendingStatusChange.id,
      });
      if (approved === false) return;
    } else if (pendingStatusChange.nextStatus === "Excluir") {
      await deletebuget(pendingStatusChange.id);
    } else if (pendingStatusChange.nextStatus === "Duplicar") {
      await handleDuplicateBudget(pendingStatusChange.id);
    }
    setPendingStatusChange(null);
    setActionModalOpen(false);
  };
  const handleActionCancel = () => {
    setPendingStatusChange(null);
    setActionModalOpen(false);
  };

  const formatCurrencyBRL = (value) => {
    const numericValue = Number(value || 0);
    return numericValue.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  };

  const getSelectedNames = (list) =>
    (list?.dados || [])
      .filter((item) => item.selected)
      .map((item) => item.name);

  const extractContactData = (contactValue) => {
    if (!contactValue) return { nome: "-", telefone: "-", email: "-" };

    if (typeof contactValue === "object") {
      return {
        nome: contactValue.nome || contactValue.name || "-",
        telefone:
          contactValue.telefone ||
          contactValue.phoneNumberFirst ||
          contactValue.phone ||
          "-",
        email: contactValue.email || "-",
      };
    }

    if (typeof contactValue === "string") {
      try {
        const parsed = JSON.parse(contactValue);
        return {
          nome: parsed.nome || parsed.name || "-",
          telefone:
            parsed.telefone || parsed.phoneNumberFirst || parsed.phone || "-",
          email: parsed.email || "-",
        };
      } catch {
        const parts = contactValue.split(" - ").map((part) => part.trim());
        return {
          nome: parts[0] || "-",
          telefone: parts[1] || "-",
          email: parts[2] || "-",
        };
      }
    }

    return { nome: "-", telefone: "-", email: "-" };
  };

  const getSellerContactData = (sellerName) => {
    const normalizedSellerName = String(sellerName || "")
      .trim()
      .toLowerCase();
    const sellerRecord = (sellersList || []).find((item) => {
      const normalizedName = String(item?.name || "")
        .trim()
        .toLowerCase();
      const normalizedEmail = String(item?.email || "")
        .trim()
        .toLowerCase();

      return (
        (normalizedSellerName && normalizedName === normalizedSellerName) ||
        (normalizedSellerName && normalizedEmail === normalizedSellerName)
      );
    });

    return {
      nome: sellerRecord?.name || sellerName || "-",
      telefone:
        sellerRecord?.phoneNumber ||
        sellerRecord?.phoneNumberFirst ||
        sellerRecord?.phone ||
        sellerRecord?.telefone ||
        "-",
      email: sellerRecord?.email || "",
    };
  };

  const formatDeliveryDeadlineLabel = (value) => {
    const normalizedValue = String(value ?? "").trim();
    if (!normalizedValue) return "-";

    if (/^\d+$/.test(normalizedValue)) {
      const days = Number(normalizedValue);
      return `${days} dia${days === 1 ? "" : "s"}`;
    }

    return normalizedValue;
  };

  const handleEmitPdf = async (record) => {
    if (!record?.id) return;

    // Placeholder para emissÃ£o do PDF
    const vehicles = getSelectedNames(record?.vehicle?.typeVehicle);
    const bodyworks = getSelectedNames(record?.vehicle?.typeBodywork);
    const total = record?.summary?.valueFreightage || 0;
    // Prioriza o valor salvo no orÃ§amento para evitar divergÃªncia entre tela e PDF.
    const savedAdditionalStopsRaw = record?.summary?.additionalStops;
    let pontosAdicionais = Number.isFinite(Number(savedAdditionalStopsRaw))
      ? Number(savedAdditionalStopsRaw)
      : NaN;

    const hasStopsArray = Array.isArray(record?.stops);
    // Base para o campo "Desc. dos Materiais": descricao dos pontos de parada.
    let stopsForPdf = hasStopsArray ? record.stops : [];

    if (!Number.isFinite(pontosAdicionais) && hasStopsArray) {
      pontosAdicionais = Math.max((record.stops.length || 0) - 2, 0);
    }

    if (
      (!Number.isFinite(pontosAdicionais) || stopsForPdf.length === 0) &&
      record?.id
    ) {
      // ANTIGO (Firestore direto) — mantido comentado so para estudo, nao apagar:
      // Buscava a subcolecao stopping_points direto no Firestore como fallback.
      //
      // try {
      //   const stopsSnapshot = await db
      //     .collection("tb_budget")
      //     .doc(record.id)
      //     .collection("stopping_points")
      //     .get();
      //
      //   const stopsFromDb = stopsSnapshot.docs.map((docSnap) => ({
      //     id: docSnap.id,
      //     ...docSnap.data(),
      //   }));
      //
      //   if (stopsForPdf.length === 0) {
      //     stopsForPdf = stopsFromDb;
      //   }
      //
      //   if (!Number.isFinite(pontosAdicionais)) {
      //     pontosAdicionais = Math.max((stopsSnapshot?.size || 0) - 2, 0);
      //   }
      // } catch (error) {
      //   console.error("Erro ao buscar pontos de parada para PDF:", error);
      //   if (!Number.isFinite(pontosAdicionais)) {
      //     pontosAdicionais = 0;
      //   }
      // }

      // NOVO (via API REST) — fetchBudgetById ja devolve o orcamento com os
      // stopping_points embutidos, numa chamada so.
      try {
        const budgetLookup = await fetchBudgetById(record.id);
        const stopsFromDb = budgetLookup.success
          ? budgetLookup.data?.stopping_points || []
          : [];

        if (stopsForPdf.length === 0) {
          stopsForPdf = stopsFromDb;
        }

        if (!Number.isFinite(pontosAdicionais)) {
          pontosAdicionais = Math.max((stopsFromDb.length || 0) - 2, 0);
        }
      } catch (error) {
        console.error("Erro ao buscar pontos de parada para PDF:", error);
        if (!Number.isFinite(pontosAdicionais)) {
          pontosAdicionais = 0;
        }
      }
    }
    const itensRecord = (record?.pricing?.products || []).map(
      (item, index) => ({
        item: index + 1,
        descricao:
          item?.nameProducts ||
          item?.description ||
          item?.descricao ||
          item?.name ||
          item?.nameProduct ||
          item?.typeService ||
          "ServiÃ§o",
        qtd: Number(item?.quantity || item?.qtd || 1),
        valor: Number(
          item?.price || item?.value || item?.valor || item?.total || 0,
        ),
        total:
          Number(item?.total || 0) ||
          Number(item?.price || item?.value || item?.valor || 0) *
            Number(item?.quantity || item?.qtd || 1),
      }),
    );
    // Mantem no PDF exatamente o texto preenchido em "Descricao" dos pontos de parada.
    const materiaisDescricao = (stopsForPdf || [])
      .map((stop) =>
        String(
          stop?.descricao || stop?.description || stop?.Descricao || "",
        ).trim(),
      )
      .filter(Boolean);
    const materiaisPdf =
      materiaisDescricao.length > 0
        ? materiaisDescricao.join(", ").toUpperCase()
        : "FRETE DEDICADO";
    const contato = extractContactData(record?.contact);
    // Reaproveita o cadastro de usuarios para que o PDF da listagem mostre os dados do vendedor escolhido.
    const vendedorContato = getSellerContactData(record?.summary?.seller);

    const dadosPdf = {
      numero: record?.numberSerial || "-",
      dataOrcamento: Utils.formatDateBR(
        record?.createData || record?.createdAt || new Date(),
      ),
      pagador: record?.clientPayment?.name || "-",
      vendedor: vendedorContato.nome,
      contatoNome:
        contato.nome !== "-" ? contato.nome : record?.summary?.seller || "-",
      contatoTelefone: contato.telefone,
      contatoEmail: contato.email,
      vendedorTelefone: vendedorContato.telefone,
      vendedorEmail: vendedorContato.email,
      origemCidade: record?.firstDelivery?.city || "-",
      origemUF: record?.firstDelivery?.uf || "-",
      destinoCidade: record?.lastDelivery?.city || "-",
      destinoUF: record?.lastDelivery?.uf || "-",
      pontosAdicionais,
      // Mantem o PDF emitido pela listagem com o mesmo formato de prazo usado em editar/salvar e emitir.
      previsao: formatDeliveryDeadlineLabel(record?.summary?.deliveryDeadline),
      // Modal vem da ocupacao configurada no orcamento.
      modal: record?.vehicle?.occupation || "-",
      veiculo: vehicles.length ? vehicles.join(", ") : "-",
      carroceria: bodyworks.length ? bodyworks.join(", ") : "-",
      peso: record?.summary?.weightCargo
        ? `${record.summary.weightCargo} kg`
        : "-",
      valorTransportado: record?.summary?.valueNF
        ? formatCurrencyBRL(record.summary.valueNF)
        : "-",
      materiais: materiaisPdf,
      valorFrete: formatCurrencyBRL(total),
      total: formatCurrencyBRL(total),
      prazoPagamento: record?.summary?.paymentCondition || "-",
      observacoes: record?.summary?.observation || "-",
      itens: itensRecord,
    };

    await gerarPdfOrcamento(dadosPdf);
    // Mantem o status Aprovado travado mesmo apos emitir o PDF novamente.
    if (record?.status?.describe !== "Aprovado") {
      await updateBudgetStatus(record.id, "Enviado");
    }
  };

  function renderStatusColor(status) {
    const chipStyle = {
      minWidth: "100px",
      maxWidth: "150px",
      borderRadius: "8px",
    };

    const commonChip = (label, color) => (
      <Stack direction="row" spacing={1}>
        <Chip label={label} color={color} style={chipStyle} />
      </Stack>
    );

    switch (status) {
      case "Aprovado":
        return commonChip(status, "success");
      case "Enviado":
        return commonChip(status, "primary");
      case "Em Aberto":
        return commonChip(status, "warning");
      case "Cancelado":
        return commonChip(status, "error");
      default:
        return commonChip(status || "Em Aberto", "warning");
    }
  }

  function cleanFilters() {
    setColumnFilters({});
    setDateRange([]);
  }

  const handleApplyCustomFilter = (filter) => {
    const newFilters = {};
    let newDateRange = [];

    if (filter.conditions && filter.conditions.length > 0) {
      filter.conditions.forEach((condition) => {
        const { column, operator, value } = condition;

        if (!column || !operator) return;

        if (column === "firstDelivery.dateColeta" || column === "dataCriacao") {
          if (operator === "between" && value && value.length === 2) {
            newDateRange = [value[0], value[1]];
          } else if (value) {
            newDateRange = [value, value];
          }
        } else if (column === "status.describe") {
          if (operator === "in" && Array.isArray(value)) {
            newFilters[column] = value;
          } else if (operator === "equals" && value) {
            newFilters[column] = [value];
          }
        } else if (
          (column === "summary.valueFreightage" || column === "valorTotal") &&
          value !== undefined &&
          value !== null &&
          value !== ""
        ) {
          const numericValue = Number(value);
          if (!Number.isNaN(numericValue)) {
            newFilters["summary.valueFreightage"] = {
              operator,
              value: numericValue,
            };
          }
        } else if (
          column === "numberSerial" &&
          value !== undefined &&
          value !== null &&
          value !== ""
        ) {
          newFilters[column] = {
            operator,
            value: Number(value),
          };
        } else {
          if (
            (operator === "contains" ||
              operator === "equals" ||
              operator === "startsWith" ||
              operator === "endsWith") &&
            value !== undefined &&
            value !== null &&
            value !== ""
          ) {
            newFilters[column] = {
              operator,
              value: String(value),
            };
          }
        }
      });
    }

    setColumnFilters(newFilters);
    setDateRange(newDateRange);
  };

  const formatVehicleBodywork = (record) => {
    const vehicles =
      record?.vehicle?.typeVehicle?.dados?.filter((v) => v.selected) || [];
    const bodyworks =
      record?.vehicle?.typeBodywork?.dados?.filter((b) => b.selected) || [];

    const vehicleNames = vehicles.map((v) => v.name);
    const bodyworkNames = bodyworks.map((b) => b.name);

    const hasMultipleVehicles = vehicleNames.length > 1;
    const hasMultipleBodyworks = bodyworkNames.length > 1;

    let vehicleDisplay = hasMultipleVehicles
      ? "Diversos"
      : vehicleNames[0] || "";
    let bodyworkDisplay = hasMultipleBodyworks
      ? "Diversos"
      : bodyworkNames[0] || "";

    if (!vehicleDisplay && !bodyworkDisplay) {
      return "";
    }

    if (vehicleDisplay && bodyworkDisplay) {
      return `${vehicleDisplay}/${bodyworkDisplay}`;
    }

    if (vehicleDisplay && !bodyworkDisplay) {
      return vehicleDisplay;
    }

    if (!vehicleDisplay && bodyworkDisplay) {
      return bodyworkDisplay;
    }

    return "";
  };

  const getRecordValueByColumnKey = (record, columnKey) => {
    if (columnKey === "veiculoCarroceria") {
      return formatVehicleBodywork(record);
    }

    const path = String(columnKey).split(".");
    let value = record;
    for (const key of path) {
      value = value?.[key];
    }
    return value;
  };

  const matchRecordWithFilter = (record, columnKey, filter, type = "text") => {
    if (filter == null || filter === "") return true;

    const recordValue = getRecordValueByColumnKey(record, columnKey);
    if (recordValue == null) return false;

    if (filter && typeof filter === "object" && filter.operator) {
      const { operator, value } = filter;
      if (value == null || value === "") return true;

      const recordStr = String(recordValue).toLowerCase();
      const valueStr = String(value).toLowerCase();

      switch (operator) {
        case "contains":
          return recordStr.includes(valueStr);
        case "equals":
          return type === "number" || type === "money"
            ? Number(recordValue) === Number(value)
            : recordStr === valueStr;
        case "startsWith":
          return recordStr.startsWith(valueStr);
        case "endsWith":
          return recordStr.endsWith(valueStr);
        case "greaterThan":
          return Number(recordValue) > Number(value);
        case "greaterThanOrEqual":
          return Number(recordValue) >= Number(value);
        case "lessThan":
          return Number(recordValue) < Number(value);
        case "lessThanOrEqual":
          return Number(recordValue) <= Number(value);
        case "notEquals":
          return Number(recordValue) !== Number(value);
        case "in":
          return Array.isArray(value)
            ? value.includes(recordValue)
            : recordValue === value;
        default:
          return true;
      }
    }

    if (type === "number") {
      return String(recordValue).includes(String(filter));
    }

    if (type === "money") {
      const filterInt =
        typeof filter === "number" ? filter : Utils.moneyToInt(filter);
      const recordInt =
        typeof recordValue === "number"
          ? Math.round(recordValue)
          : Utils.moneyToInt(recordValue);
      return String(recordInt).includes(String(filterInt));
    }

    return String(recordValue)
      .toLowerCase()
      .includes(String(filter).toLowerCase());
  };

  const getColumnSearchProps = (dataIndex, type = "text", maxLength = 40) => {
    const columnKey = Array.isArray(dataIndex)
      ? dataIndex.join(".")
      : dataIndex;

    return {
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys = [],
        confirm,
        clearFilters,
        close,
      }) => (
        <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
          <Input
            ref={searchInput}
            placeholder={`Buscar ${columnKey}`}
            value={selectedKeys[0] ?? ""}
            maxLength={type === "text" ? maxLength : undefined}
            onChange={(e) => {
              let value = e.target.value ?? "";
              if (type === "number") {
                value = value.replace(/\D/g, "");
              } else if (type === "money") {
                value = value.replace(/\D/g, "");
                value = (Number(value) / 100).toLocaleString("pt-BR", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                });
              } else if (type === "text") {
                try {
                  value = value.replace(/[0-9]/g, "");
                } catch (err) {
                  value = value.replace(/\d/g, "");
                }
              }

              setSelectedKeys(value ? [value] : []);
            }}
            onPressEnter={() => {
              handleSearch(selectedKeys, confirm, columnKey);
            }}
            style={{ marginBottom: 8, display: "block" }}
          />

          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, columnKey)}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              Buscar
            </Button>

            <Button
              onClick={() => {
                if (clearFilters) {
                  handleReset(clearFilters);
                }

                columnFilters[columnKey] &&
                  setColumnFilters((prev) => {
                    const updatedFilters = { ...prev };
                    delete updatedFilters[columnKey];
                    return updatedFilters;
                  });

                confirm();
              }}
              size="small"
              style={{ width: 90 }}
            >
              Reiniciar
            </Button>

            <Button type="link" size="small" onClick={() => close()}>
              Fechar
            </Button>
          </Space>
        </div>
      ),

      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
      ),

      onFilter: (value, record) => {
        const activeFilter = columnFilters[columnKey] ?? value;
        return matchRecordWithFilter(record, columnKey, activeFilter, type);
      },

      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },

      render: (text) =>
        searchedColumn === columnKey ? (
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ""}
          />
        ) : (
          text
        ),
    };
  };

  const getDateOnly = (value) => {
    if (!value) return null;

    if (typeof value === "string") {
      // Datas ISO completas (ex: createData) trazem hora/timezone, ex: "2026-07-22T14:30:00.000Z".
      // O split simples por "-" so funciona pra datas puras "YYYY-MM-DD" (ex: firstDelivery.dateColeta).
      if (value.includes("T")) {
        const d = new Date(value);
        if (isNaN(d.getTime())) return null;
        return new Date(d.getFullYear(), d.getMonth(), d.getDate());
      }

      const [year, month, day] = value.split("-").map(Number);
      if (!year || !month || !day) return null;
      return new Date(year, month - 1, day);
    }

    if (typeof value === "object" && typeof value.toDate === "function") {
      const d = value.toDate();
      if (!(d instanceof Date) || isNaN(d.getTime())) return null;
      return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    }

    if (value instanceof Date) {
      if (isNaN(value.getTime())) return null;
      return new Date(value.getFullYear(), value.getMonth(), value.getDate());
    }

    return null;
  };

  const getColumnSearchPropsDate = () => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <DatePickerMenu
          onChange={(dates) => {
            handleDateRangeChange(dates);
            setSelectedKeys(dates ? [dates] : []);
          }}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearchDate(confirm)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => clearFilters && handleResetDate(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reiniciar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <CalendarOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (_, record) => {
      if (!dateRange || !dateRange.length) return true;

      const [startDate, endDate] = dateRange;

      const dataCriacao = record.createdAt
        ? getDateOnly(record.createdAt)
        : null;
      if (!dataCriacao) {
        const dateColeta = getDateOnly(record.firstDelivery?.dateColeta);
        if (!dateColeta) return false;

        const start = getDateOnly(startDate);
        const end = getDateOnly(endDate);

        if (start && end && start.getTime() === end.getTime()) {
          return dateColeta.getTime() === start.getTime();
        }

        if (start && !end) {
          return dateColeta.getTime() >= start.getTime();
        }

        if (start && end) {
          return (
            dateColeta.getTime() >= start.getTime() &&
            dateColeta.getTime() <= end.getTime()
          );
        }

        return true;
      }

      const start = getDateOnly(startDate);
      const end = getDateOnly(endDate);

      if (start && end && start.getTime() === end.getTime()) {
        return dataCriacao.getTime() === start.getTime();
      }

      if (start && !end) {
        return dataCriacao.getTime() >= start.getTime();
      }

      if (start && end) {
        return (
          dataCriacao.getTime() >= start.getTime() &&
          dataCriacao.getTime() <= end.getTime()
        );
      }

      return true;
    },
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === "dataCriacao" ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const getBudgetStatus = (record) => {
    return record?.status?.describe || "Em Aberto";
  };

  const getStatusSortWeight = (status) => {
    const statusWeight = {
      Cancelado: 1,
      "Em Aberto": 2,
      Enviado: 3,
      Aprovado: 4,
    };

    return statusWeight[status] ?? 99;
  };

  const getFilteredDataWithoutStatus = () => {
    let filteredData = [...datas];

    if (dateRange && dateRange.length) {
      const [startDate, endDate] = dateRange;
      filteredData = filteredData.filter((record) => {
        const dataCriacao = record.createdAt
          ? getDateOnly(record.createdAt)
          : getDateOnly(record.firstDelivery?.dateColeta);
        if (!dataCriacao) return false;

        const start = getDateOnly(startDate);
        const end = getDateOnly(endDate);

        if (start && end && start.getTime() === end.getTime()) {
          return dataCriacao.getTime() === start.getTime();
        }

        if (start && !end) {
          return dataCriacao.getTime() >= start.getTime();
        }

        if (start && end) {
          return (
            dataCriacao.getTime() >= start.getTime() &&
            dataCriacao.getTime() <= end.getTime()
          );
        }

        return true;
      });
    }

    Object.keys(columnFilters).forEach((columnKey) => {
      if (columnKey === "status.describe") return;

      const filterValue = columnFilters[columnKey];
      if (filterValue == null || filterValue === "") return;

      filteredData = filteredData.filter((record) => {
        if (columnKey === "dataCriacao") return true;
        const isNumber = columnKey === "numberSerial";
        const isMoney =
          columnKey === "summary.valueFreightage" || columnKey === "valorTotal";
        const type = isMoney ? "money" : isNumber ? "number" : "text";
        return matchRecordWithFilter(record, columnKey, filterValue, type);
      });
    });

    return filteredData;
  };

  const getUniqueStatusValues = () => {
    const filteredData = getFilteredDataWithoutStatus();
    const uniqueStatuses = new Set();
    filteredData.forEach((record) => {
      uniqueStatuses.add(getBudgetStatus(record));
    });

    return Array.from(uniqueStatuses).sort((a, b) => {
      const diff = getStatusSortWeight(a) - getStatusSortWeight(b);
      return diff !== 0 ? diff : a.localeCompare(b);
    });
  };

  const getStatusFilterProps = () => {
    const statusOptions = getUniqueStatusValues();

    return {
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys = [],
        confirm,
        clearFilters,
      }) => {
        const filteredOptions = statusSearchText
          ? statusOptions.filter((status) =>
              status.toLowerCase().includes(statusSearchText.toLowerCase()),
            )
          : statusOptions;

        const handleSelectAll = (checked) => {
          if (checked) {
            setSelectedKeys(filteredOptions);
          } else {
            setSelectedKeys([]);
          }
        };

        const handleChange = (status, checked) => {
          if (checked) {
            setSelectedKeys([...selectedKeys, status]);
          } else {
            setSelectedKeys(selectedKeys.filter((key) => key !== status));
          }
        };

        const allSelected =
          filteredOptions.length > 0 &&
          filteredOptions.every((option) => selectedKeys.includes(option));

        const someSelected =
          filteredOptions.some((option) => selectedKeys.includes(option)) &&
          !allSelected;

        return (
          <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
            <Input
              ref={statusFilterRef}
              placeholder="Buscar..."
              value={statusSearchText}
              onChange={(e) => setStatusSearchText(e.target.value)}
              style={{ marginBottom: 8 }}
              allowClear
              onPressEnter={() => confirm()}
            />
            <div style={{ maxHeight: 250, overflowY: "auto", marginBottom: 8 }}>
              <div style={{ marginBottom: 4 }}>
                <Checkbox
                  indeterminate={someSelected}
                  checked={allSelected}
                  onChange={(e) => handleSelectAll(e.target.checked)}
                >
                  (Selecionar todos)
                </Checkbox>
              </div>
              {filteredOptions.map((status) => (
                <div key={status} style={{ marginBottom: 4 }}>
                  <Checkbox
                    checked={selectedKeys.includes(status)}
                    onChange={(e) => handleChange(status, e.target.checked)}
                  >
                    {status}
                  </Checkbox>
                </div>
              ))}
            </div>
            <Space>
              <Button
                onClick={() => {
                  if (clearFilters) {
                    clearFilters();
                  }
                  setSelectedKeys([]);
                  setStatusSearchText("");
                  setColumnFilters((prev) => {
                    const updatedFilters = { ...prev };
                    delete updatedFilters["status.describe"];
                    return updatedFilters;
                  });
                  confirm();
                }}
                size="small"
                style={{ width: 90 }}
              >
                Resetar
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  setColumnFilters((prev) => ({
                    ...prev,
                    "status.describe": selectedKeys,
                  }));
                  confirm();
                }}
                size="small"
                style={{ width: 90 }}
              >
                Aplicar
              </Button>
            </Space>
          </div>
        );
      },
      filterSearch: true,
      filterMultiple: true,
      onFilter: (value, record) => getBudgetStatus(record) === value,
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTimeout(() => statusFilterRef.current?.select(), 100);
          setStatusSearchText("");
        }
      },
    };
  };

  const columns = [
    {
      title: "Data de Criação",
      dataIndex: "createdAt",
      key: "dataCriacao",
      align: "center",
      filteredValue: dateRange && dateRange.length ? [dateRange] : null,
      ...getColumnSearchPropsDate(),
      sorter: (a, b) => {
        const dateA = a.createdAt || a.firstDelivery?.dateColeta;
        const dateB = b.createdAt || b.firstDelivery?.dateColeta;

        if (!dateA) return -1;
        if (!dateB) return 1;

        const dateAObj = getDateOnly(dateA);
        const dateBObj = getDateOnly(dateB);

        if (!dateAObj) return -1;
        if (!dateBObj) return 1;

        return dateAObj.getTime() - dateBObj.getTime();
      },
      render: (createdAt, record) => {
        const dateToFormat = createdAt || record.firstDelivery?.dateColeta;
        const parsedDate = getDateOnly(dateToFormat);
        return parsedDate ? format(parsedDate, "dd/MM/yyyy") : "";
      },
    },
    {
      title: "Pagador ",
      dataIndex: ["clientPayment", "name"],
      key: "pagador",
      align: "center",
      filteredValue: columnFilters["clientPayment.name"]
        ? [columnFilters["clientPayment.name"]]
        : null,
      ...getColumnSearchProps(["clientPayment", "name"], "text", 40),
      sorter: (a, b) => {
        const nameA = a.clientPayment?.name || "";
        const nameB = b.clientPayment?.name || "";
        return nameA.localeCompare(nameB);
      },
    },
    {
      title: "Vendedor",
      dataIndex: "sellerName",
      key: "vendedor",
      align: "center",
      filteredValue: columnFilters["sellerName"]
        ? [columnFilters["sellerName"]]
        : null,
      ...getColumnSearchProps("sellerName", "text", 40),
      sorter: (a, b) => {
        const nameA = a.sellerName || "";
        const nameB = b.sellerName || "";
        return nameA.localeCompare(nameB);
      },
      render: (text, record) => {
        return record.summary?.seller || text || "";
      },
    },
    {
      title: "Origem",
      dataIndex: ["firstDelivery", "city"],
      key: "origem",
      align: "center",
      filteredValue: columnFilters["firstDelivery.city"]
        ? [columnFilters["firstDelivery.city"]]
        : null,
      ...getColumnSearchProps(["firstDelivery", "city"], "text", 40),
      render: (city, record) => {
        const uf = record.firstDelivery?.uf || "";
        return city && uf ? `${city} - ${uf}` : city || "";
      },
      sorter: (a, b) => {
        const cityA = a.firstDelivery?.city || "";
        const cityB = b.firstDelivery?.city || "";
        return cityA.localeCompare(cityB);
      },
    },
    {
      title: "Destino",
      dataIndex: ["lastDelivery", "city"],
      key: "destino",
      align: "center",
      filteredValue: columnFilters["lastDelivery.city"]
        ? [columnFilters["lastDelivery.city"]]
        : null,
      ...getColumnSearchProps(["lastDelivery", "city"], "text", 40),
      render: (city, record) => {
        const uf = record.lastDelivery?.uf || "";
        return city && uf ? `${city} - ${uf}` : city || "";
      },
      sorter: (a, b) => {
        const cityA = a.lastDelivery?.city || "";
        const cityB = b.lastDelivery?.city || "";
        return cityA.localeCompare(cityB);
      },
    },
    {
      title: "Veículo/Carroceria",
      dataIndex: "vehicle",
      key: "veiculoCarroceria",
      align: "center",
      filteredValue: columnFilters["veiculoCarroceria"]
        ? [columnFilters["veiculoCarroceria"]]
        : null,
      ...getColumnSearchProps("veiculoCarroceria", "text", 40),
      render: (vehicle, record) => {
        return formatVehicleBodywork(record);
      },
      sorter: (a, b) => {
        const vehicleA = formatVehicleBodywork(a);
        const vehicleB = formatVehicleBodywork(b);
        return vehicleA.localeCompare(vehicleB);
      },
    },
    {
      title: "Valor Total",
      dataIndex: ["summary", "valueFreightage"],
      key: "valorTotal",
      align: "center",
      filteredValue: columnFilters["summary.valueFreightage"]
        ? [columnFilters["summary.valueFreightage"]]
        : null,
      ...getColumnSearchProps(["summary", "valueFreightage"], "money"),
      render: (valueFreightage) =>
        `${(valueFreightage || 0).toLocaleString("pt-br", { style: "currency", currency: "BRL" })}`,
      sorter: (a, b) => {
        const valueA = a.summary?.valueFreightage || 0;
        const valueB = b.summary?.valueFreightage || 0;
        return valueA - valueB;
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      align: "center",
      filteredValue: columnFilters["status.describe"]
        ? columnFilters["status.describe"]
        : null,
      ...getStatusFilterProps(),
      render: (status) => {
        const normalizedStatus = status?.describe || "Em Aberto";
        return (
          <Tooltip title={normalizedStatus}>
            <div>{renderStatusColor(normalizedStatus)}</div>
          </Tooltip>
        );
      },
      sorter: (a, b) => {
        const statusA = getBudgetStatus(a);
        const statusB = getBudgetStatus(b);
        const statusWeightDiff =
          getStatusSortWeight(statusA) - getStatusSortWeight(statusB);

        if (statusWeightDiff !== 0) {
          return statusWeightDiff;
        }

        return statusA.localeCompare(statusB);
      },
    },
    {
      title: "Ações",
      key: "actions",
      align: "center",
      render: (_, record) => (
        <Space>
          <Tooltip title="Emitir PDF">
            <Button
              type="link"
              icon={<FilePdfOutlined style={{ fontSize: 24 }} />}
              onClick={() => handleEmitPdf(record)}
            />
          </Tooltip>

          {user?.permissoes?.budget?.isEdit ||
          user?.permissoes?.orcamento?.editar ? (
            <Button
              type="link"
              icon={<EditOutlinedIcon />}
              onClick={() => navigate(`/budget/${record.id}`)}
            />
          ) : user?.permissoes?.budget?.isView ||
            user?.permissoes?.orcamento?.visualizar ? (
            <Button
              type="link"
              icon={<VisibilityIcon />}
              onClick={() =>
                navigate(`/budget/${record.id}`, { state: { viewOnly: true } })
              }
            />
          ) : null}
          {["Enviado", "Aprovado"].includes(record.status?.describe) ? (
            <Dropdown
              overlay={
                <Menu
                  onClick={({ key }) => {
                    if (key === "aprovar") {
                      handleBudgetStatusChange(record.id, "Aprovado");
                    } else if (key === "cancelar") {
                      handleBudgetStatusChange(record.id, "Cancelado");
                    } else if (key === "duplicar") {
                      handleBudgetStatusChange(record.id, "Duplicar");
                    } else if (key === "delete") {
                      handleBudgetStatusChange(record.id, "Excluir");
                    }
                  }}
                  style={{ minWidth: 180, padding: "8px 0", borderRadius: 8 }}
                >
                  {record.status?.describe === "Enviado" && (
                    <Menu.Item
                      key="aprovar"
                      style={{ padding: "10px 16px", color: "#52c41a" }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <CheckCircleOutlined />
                        Aprovar
                      </div>
                    </Menu.Item>
                  )}
                  <Menu.Item
                    key="cancelar"
                    style={{ padding: "10px 16px", color: "#f5222d" }}
                  >
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 8 }}
                    >
                      <CloseCircleOutlined />
                      Cancelar
                    </div>
                  </Menu.Item>
                  <Menu.Item
                    key="duplicar"
                    style={{ padding: "10px 16px", color: "#1890ff" }}
                  >
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 8 }}
                    >
                      <CopyOutlined />
                      Duplicar
                    </div>
                  </Menu.Item>
                  {user?.permissoes?.budget?.isDelete ||
                  user?.permissoes?.orcamento?.excluir ? (
                    <Menu.Item
                      key="delete"
                      style={{ padding: "10px 16px", color: "#f5222d" }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <DeleteOutlinedIcon />
                        Excluir
                      </div>
                    </Menu.Item>
                  ) : (
                    ""
                  )}
                </Menu>
              }
              trigger={["click"]}
            >
              <Button
                type="text"
                icon={<SmallDashOutlined style={{ fontSize: 20 }} />}
              />
            </Dropdown>
          ) : user?.permissoes?.budget?.isDelete ||
            user?.permissoes?.orcamento?.excluir ? (
            <Button
              type="link"
              danger
              icon={<DeleteOutlinedIcon />}
              onClick={() => handleBudgetStatusChange(record.id, "Excluir")}
            />
          ) : (
            ""
          )}
        </Space>
      ),
    },
  ];

  const sortedData = [...datas].sort((a, b) => {
    const statusA = getBudgetStatus(a);
    const statusB = getBudgetStatus(b);
    const statusWeightDiff =
      getStatusSortWeight(statusA) - getStatusSortWeight(statusB);

    if (statusWeightDiff !== 0) {
      return statusWeightDiff;
    }

    return statusA.localeCompare(statusB);
  });

  return (
    <>
      <ModernAlertDialog
        open={actionModalOpen}
        handleClose={handleActionCancel}
        title={actionModalConfig.title}
        msg={actionModalConfig.message}
        confirmLabel="Sim"
        cancelLabel="Não"
        showCancel
        onConfirm={handleActionConfirm}
        onCancel={handleActionCancel}
      />
      <ModalFilter
        visible={openModalFilter}
        onClose={() => setOpenModalFilter(false)}
        onApply={handleApplyCustomFilter}
        availableColumns={budgetModalFilterColumns}
        selectOptionsMap={{ "status.describe": budgetStatusOptions }}
        storageKeySuffix="budgetCustomFilters"
      />
      <div className="table-wrapper-with-actions">
        <Table
          columns={columns}
          dataSource={sortedData}
          rowKey="id"
          loading={loading}
          pagination={{
            current,
            pageSize,
            total: sortedData.length,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50", "100"],
            hideOnSinglePage: false,
            onChange: (page, size) => {
              setCurrent(page);
              setPageSize(size);
            },
          }}
        />
      </div>
      <GlobalSuccessModal
        open={openSuccessModal}
        handleClose={() => setOpenSuccessModal(false)}
        title={successModalTitle}
      />
    </>
  );
};

export default DataOrcamentoTable;
